import { platformNames } from '@/common/constants'

export const getPlatformName = provider => platformNames[provider]

export const getMissingCustomsFields = ({ item, shipsWithCustoms }) => {
  return {
    hs_code: shipsWithCustoms && !item.hs_code,
    country: shipsWithCustoms && !item.country,
    unit_cost: shipsWithCustoms && !Number(item.unit_cost),
    weight: shipsWithCustoms && !Number(item.weight),
  }
}
